import feCommonDataHolder from '../fe-common.initialize.js';

const REGION_ID_HEADER = 'x-gctx-request-origin-region-id';
const REGION_LANG_HEADER = 'x-gctx-request-origin-locale';
const REGION_DETAILS_LOCAL_STORAGE_KEY = 'REGION_DETAILS';
const isBrowser = ()=>typeof window !== 'undefined';
const getFromLocalStorageWithExpiry = (key)=>{
    if (typeof localStorage === 'undefined') return null;
    try {
        const val = localStorage.getItem(key);
        if (val) {
            const data = JSON.parse(val);
            return data?.value;
        }
    } catch (error) {
        console.info('getFromLocalStorageWithExpiry error', error, key);
    }
    return null;
};
const getLocalisationDataFromStorage = ()=>{
    const { enableI18n } = feCommonDataHolder.getFlags();
    if (!enableI18n) return null;
    if (!isBrowser()) return null;
    return JSON.parse(getFromLocalStorageWithExpiry(REGION_DETAILS_LOCAL_STORAGE_KEY) ?? 'null');
};

export { REGION_DETAILS_LOCAL_STORAGE_KEY, REGION_ID_HEADER, REGION_LANG_HEADER, getFromLocalStorageWithExpiry, getLocalisationDataFromStorage };
//# sourceMappingURL=utils.js.map
